import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  CardMedia,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { send } from "emailjs-com";
import useHttp from "../../Hooks/use-http";
import DefaultImage from "../../Assets/adminAlternative.png";

const DeleteDriver = ({
  selectedCorporate,
  setSelectedCorporate,
  driverData,
  isAddDeletePrivateDrivesClicked,
  setIsDeleteDialogOpen,
  onCloseModal,
  selectedDriverType,
  setSelectedDriverType,
  setIsApiCall,
  setAnchorEl,
}) => {
  const [filteredCorporateData, setFilteredCorporateData] = useState([]);
  const [availableDriverTypes, setAvailableDriverTypes] = useState([]);
  const { isLoading, sendRequest } = useHttp();

  // useEffect(() => {
  //   if (driverData?.corporates) {
  //     // Determine the available driver types
  //     const driverTypes = Array.from(
  //       new Set(driverData.corporates.map((c) => c.types))
  //     );
  //     setAvailableDriverTypes(driverTypes);
  //     // setSelectedDriverType(driverTypes.length === 1 ? driverTypes[0] : null);
  //     if (driverTypes.length === 1) {
  //       setSelectedDriverType(driverTypes[0]);
  //     } else if (driverTypes.length === 2 && driverTypes.includes("private")) {
  //       setSelectedDriverType("private");
  //     } else {
  //       setSelectedDriverType(null);
  //     }
  //   }
  // }, [driverData]);

  useEffect(() => {
    if (driverData?.corporates) {
      // Get all unique driver types by splitting the semicolon-separated strings
      const allTypes = driverData.corporates.flatMap((corporate) =>
        corporate.types.split(";").map((type) => type.trim())
      );
      const uniqueTypes = [...new Set(allTypes)];

      setAvailableDriverTypes(uniqueTypes);

      // Set default selected type
      if (uniqueTypes.length === 1) {
        setSelectedDriverType(uniqueTypes[0]);
      } else if (uniqueTypes.length === 2 && uniqueTypes.includes("private")) {
        setSelectedDriverType("private");
      } else {
        setSelectedDriverType(null);
      }
    }
  }, [driverData]);

  useEffect(() => {
    if (selectedDriverType) {
      const filteredData = driverData.corporates.filter((corporate) => {
        // Split and trim types to handle multi-type corporates
        const typesArray = corporate.types
          .split(";")
          .map((type) => type.trim());
        return typesArray.includes(selectedDriverType);
      });

      setFilteredCorporateData(filteredData);
    }
  }, [selectedDriverType, driverData]);

  const handleCorporateChange = (event, newValue) => {
    const selected = filteredCorporateData.find(
      (corporate) => corporate.name === newValue
    );
    setSelectedCorporate(selected ? [selected] : []);
  };

  const handleDriverTypeChange = (event) => {
    setSelectedDriverType(event.target.value);
  };

  const handleDeleteDriver = async () => {
    // isAddDeletePrivateDrivesClicked(true);
    await sendRequest({
      // url: updateAddDriverButton,
      url: "/deletecorporatedriver",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: {
        emailID: localStorage.getItem("user"),
        data: {
          emailID: driverData?.emailID,
          corporateID: selectedCorporate?.[0]?.corporateID,
          // type: availableDriverTypes?.[0] || "",
          type: selectedDriverType || "",
        },
      },
    });

    setTimeout(() => setIsDeleteDialogOpen(false), 10000);
    setIsApiCall(true);
    setAnchorEl(null);
    // toast.success("Removed successfully");
    onCloseModal();
  };

  return (
    <div>
      <Box
        sx={{
          backgroundColor: "rgba(34, 137, 203, 255)",
          color: "white",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "-24px",
          flexDirection: "row",
        }}
      >
        <Typography variant="h7" component="div">
          REMOVE DRIVER
        </Typography>
      </Box>
      <Card sx={{ display: "flex", marginTop: "10%" }}>
        <CardMedia
          component="img"
          style={{
            height: "100px",
            width: "24%",
            borderRadius: "50%",
            padding: "4px",
          }}
          image={driverData.DriverImage || DefaultImage}
          alt="Driver Image"
        />
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <CardContent>
            <Typography component="div" variant="h6">
              {driverData?.fName + " " + driverData?.lName}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              component="div"
            >
              {driverData?.emailID}
            </Typography>
            <Typography
              variant="subtitle2"
              color="text.secondary"
              component="div"
            >
              {driverData?.vehicleModal} {driverData?.vehicleNumber}
            </Typography>
          </CardContent>
        </Box>
      </Card>

      {availableDriverTypes.length > 0 && (
        <FormControl component="fieldset" sx={{ marginTop: "10px" }}>
          <FormLabel component="legend">Driver Type</FormLabel>
          <RadioGroup
            value={selectedDriverType}
            onChange={handleDriverTypeChange}
          >
            {/* <div style={{ display: "flex", gap: "30%" }}>
              {availableDriverTypes.includes("private") && (
                <FormControlLabel
                  value="private"
                  control={<Radio />}
                  label="Private"
                />
              )}
              {availableDriverTypes.includes("shuttle") && (
                <FormControlLabel
                  value="shuttle"
                  control={<Radio />}
                  label="Shuttle"
                />
              )}
            </div> */}

            <div style={{ display: "flex", gap: "30%" }}>
              {availableDriverTypes.map((type) => (
                <FormControlLabel
                  key={type}
                  value={type}
                  control={<Radio />}
                  label={type.charAt(0).toUpperCase() + type.slice(1)}
                />
              ))}
            </div>
          </RadioGroup>
        </FormControl>
      )}

      <Autocomplete
        id="corporate-filter"
        options={
          filteredCorporateData &&
          filteredCorporateData?.map((data) => data?.name)
        }
        sx={{ width: 250 }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            placeholder="Search Corporate Name"
            label="Corporate Name"
          />
        )}
        onChange={(e, newValue) => handleCorporateChange(e, newValue)}
        value={
          selectedCorporate && selectedCorporate?.length > 0
            ? selectedCorporate[0]?.name
            : ""
        }
      />

      <button
        style={{
          backgroundColor: "#88BCDF",
          color: "white",
          border: "none",
          borderRadius: "4px",
          padding: "8px 14px",
          fontSize: "12px",
          cursor: "pointer",
          transition: "background-color 0.3s ease",
          marginTop: "10px",
          marginLeft: "80%",
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#2289CB")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#88BCDF")}
        onClick={handleDeleteDriver}
        disabled={!selectedDriverType || !selectedCorporate.length}
      >
        REMOVE
      </button>
    </div>
  );
};

export default DeleteDriver;
